import { DataGridColSettings } from '@/components/DataGrid/utils';
import {
  BuildingInspection,
  BuildingRecord,
} from '@/pages/Tools/BuildingInspection/Models';

export const buildingRecordDataGridCols: DataGridColSettings[] = [
  {
    field: 'type',
    headerName: 'Type',
    visible: true,
  },
  {
    field: 'name',
    headerName: 'Property Name',
    visible: true,
  },
  {
    field: 'streetAddress',
    headerName: 'Street Address',
    visible: true,
  },
  {
    field: 'city',
    headerName: 'City',
    visible: true,
  },
  {
    field: 'zipCode',
    headerName: 'Zip code',
    visible: true,
  },
];

export const inspectionsDataGridCols: DataGridColSettings[] = [
  {
    field: 'type',
    headerName: 'Type',
    visible: true,
  },
  {
    field: 'scope',
    headerName: 'Scope',
    visible: true,
  },
  {
    field: 'assignedTo',
    headerName: 'Assigned To',
    visible: true,
  },
  {
    field: 'requestedDate',
    headerName: 'Requested Date',
    visible: true,
  },
  {
    field: 'status',
    headerName: 'Status',
    visible: true,
  },
  {
    field: 'actions',
    headerName: 'Actions',
    width: 180,
    visible: true,
  },
];

export const feesDataGridCols: DataGridColSettings[] = [
  {
    field: 'datePayed',
    headerName: 'Date',
    visible: true,
  },
  {
    field: 'fee',
    headerName: 'Amount',
    visible: true,
  },
  {
    field: 'receiptNumber',
    headerName: 'Invoice number',
    visible: true,
  },
  {
    field: 'actions',
    headerName: 'Actions',
    visible: true,
  },
];

export const allBuildingRecords: BuildingRecord[] = [
  {
    _id: 'bld-001',
    type: 'Building',
    name: "Happy's Donuts",
    streetAddress: '1234 Hill Street',
    city: 'New York',
    zipCode: '78645',
  },
  {
    _id: 'bld-002',
    type: 'Building',
    name: 'Tech Innovations',
    streetAddress: '5678 Maple Avenue',
    city: 'New York',
    zipCode: '94016',
  },
  {
    _id: 'bld-003',
    type: 'Building',
    name: 'Bistro Gourmet',
    streetAddress: '9102 Oak Road',
    city: 'New York',
    zipCode: '60614',
  },
  {
    _id: 'bld-004',
    type: 'Building',
    name: 'Logistics Hub',
    streetAddress: '3456 Pine Lane',
    city: 'New York',
    zipCode: '90001',
  },
  {
    _id: 'bld-005',
    type: 'Building',
    name: 'Morning Brew',
    streetAddress: '7890 Cedar Boulevard',
    city: 'New York',
    zipCode: '98101',
  },
  {
    _id: 'bld-006',
    type: 'Building',
    name: 'Art Space',
    streetAddress: '1357 Birch Street',
    city: 'New York',
    zipCode: '33101',
  },
  {
    _id: 'bld-007',
    type: 'Building',
    name: 'Gadget World',
    streetAddress: '2468 Spruce Avenue',
    city: 'New York',
    zipCode: '02101',
  },
  {
    _id: 'bld-008',
    type: 'Building',
    name: 'Fit Nation',
    streetAddress: '3690 Elm Street',
    city: 'New York',
    zipCode: '78701',
  },
  {
    _id: 'bld-009',
    type: 'Building',
    name: 'Cineplex Cinema',
    streetAddress: '1594 Walnut Drive',
    city: 'New York',
    zipCode: '80201',
  },
  {
    _id: 'bld-010',
    type: 'Building',
    name: 'City Library',
    streetAddress: '7531 Maple Street',
    city: 'New York',
    zipCode: '19101',
  },
];

export const allInspections: BuildingInspection[] = [
  {
    _id: 'ins-001-1',
    type: 'Complaint',
    scope: 'Install fire alarm',
    assignedTo: 'Dominik Strassman',
    requestedDate: '2025-09-11',
    status: 'Passed',
    building_id: 'bld-001',
  },
  {
    _id: 'ins-001-2',
    type: 'Complaint',
    scope: 'Install fire alarm',
    assignedTo: 'Dominik Strassman',
    requestedDate: '2025-09-11',
    status: 'Failed',
    building_id: 'bld-001',
  },
  {
    _id: 'ins-001-3',
    type: 'Complaint',
    scope: 'Safety walkthrough',
    assignedTo: 'Dominik Strassman',
    requestedDate: '2025-09-12',
    status: 'Pending',
    building_id: 'bld-001',
  },

  {
    _id: 'ins-002-1',
    type: 'Complaint',
    scope: 'Install fire alarm',
    assignedTo: 'Dominik Strassman',
    requestedDate: '2025-09-11',
    status: 'Pending',
    building_id: 'bld-002',
  },
  {
    _id: 'ins-002-2',
    type: 'Complaint',
    scope: 'Install fire alarm',
    assignedTo: 'Dominik Strassman',
    requestedDate: '2025-09-11',
    status: 'Failed',
    building_id: 'bld-002',
  },
  {
    _id: 'ins-002-3',
    type: 'Complaint',
    scope: 'Safety walkthrough',
    assignedTo: 'Dominik Strassman',
    requestedDate: '2025-09-12',
    status: 'Pending',
    building_id: 'bld-002',
  },

  {
    _id: 'ins-003-1',
    type: 'Complaint',
    scope: 'Install fire alarm',
    assignedTo: 'Dominik Strassman',
    requestedDate: '2025-09-11',
    status: 'Pending',
    building_id: 'bld-003',
  },
  {
    _id: 'ins-003-2',
    type: 'Complaint',
    scope: 'Install fire alarm',
    assignedTo: 'Dominik Strassman',
    requestedDate: '2025-09-11',
    status: 'Failed',
    building_id: 'bld-003',
  },
  {
    _id: 'ins-003-3',
    type: 'Complaint',
    scope: 'Safety walkthrough',
    assignedTo: 'Dominik Strassman',
    requestedDate: '2025-09-12',
    status: 'Pending',
    building_id: 'bld-003',
  },

  {
    _id: 'ins-004-1',
    type: 'Complaint',
    scope: 'Install fire alarm',
    assignedTo: 'Dominik Strassman',
    requestedDate: '2025-09-11',
    status: 'Pending',
    building_id: 'bld-004',
  },
  {
    _id: 'ins-004-2',
    type: 'Complaint',
    scope: 'Install fire alarm',
    assignedTo: 'Dominik Strassman',
    requestedDate: '2025-09-11',
    status: 'Failed',
    building_id: 'bld-004',
  },
  {
    _id: 'ins-004-3',
    type: 'Complaint',
    scope: 'Safety walkthrough',
    assignedTo: 'Dominik Strassman',
    requestedDate: '2025-09-12',
    status: 'Pending',
    building_id: 'bld-004',
  },

  {
    _id: 'ins-005-1',
    type: 'Complaint',
    scope: 'Install fire alarm',
    assignedTo: 'Dominik Strassman',
    requestedDate: '2025-09-11',
    status: 'Pending',
    building_id: 'bld-005',
  },
  {
    _id: 'ins-005-2',
    type: 'Complaint',
    scope: 'Install fire alarm',
    assignedTo: 'Dominik Strassman',
    requestedDate: '2025-09-11',
    status: 'Failed',
    building_id: 'bld-005',
  },
  {
    _id: 'ins-005-3',
    type: 'Complaint',
    scope: 'Safety walkthrough',
    assignedTo: 'Dominik Strassman',
    requestedDate: '2025-09-12',
    status: 'Pending',
    building_id: 'bld-005',
  },

  {
    _id: 'ins-006-1',
    type: 'Complaint',
    scope: 'Install fire alarm',
    assignedTo: 'Dominik Strassman',
    requestedDate: '2025-09-11',
    status: 'Pending',
    building_id: 'bld-006',
  },
  {
    _id: 'ins-006-2',
    type: 'Complaint',
    scope: 'Install fire alarm',
    assignedTo: 'Dominik Strassman',
    requestedDate: '2025-09-11',
    status: 'Failed',
    building_id: 'bld-006',
  },
  {
    _id: 'ins-006-3',
    type: 'Complaint',
    scope: 'Safety walkthrough',
    assignedTo: 'Dominik Strassman',
    requestedDate: '2025-09-12',
    status: 'Pending',
    building_id: 'bld-006',
  },

  {
    _id: 'ins-007-1',
    type: 'Complaint',
    scope: 'Install fire alarm',
    assignedTo: 'Dominik Strassman',
    requestedDate: '2025-09-11',
    status: 'Pending',
    building_id: 'bld-007',
  },
  {
    _id: 'ins-007-2',
    type: 'Complaint',
    scope: 'Install fire alarm',
    assignedTo: 'Dominik Strassman',
    requestedDate: '2025-09-11',
    status: 'Failed',
    building_id: 'bld-007',
  },
  {
    _id: 'ins-007-3',
    type: 'Complaint',
    scope: 'Safety walkthrough',
    assignedTo: 'Dominik Strassman',
    requestedDate: '2025-09-12',
    status: 'Pending',
    building_id: 'bld-007',
  },

  {
    _id: 'ins-008-1',
    type: 'Complaint',
    scope: 'Install fire alarm',
    assignedTo: 'Dominik Strassman',
    requestedDate: '2025-09-11',
    status: 'Pending',
    building_id: 'bld-008',
  },
  {
    _id: 'ins-008-2',
    type: 'Complaint',
    scope: 'Install fire alarm',
    assignedTo: 'Dominik Strassman',
    requestedDate: '2025-09-11',
    status: 'Failed',
    building_id: 'bld-008',
  },
  {
    _id: 'ins-008-3',
    type: 'Complaint',
    scope: 'Safety walkthrough',
    assignedTo: 'Dominik Strassman',
    requestedDate: '2025-09-12',
    status: 'Pending',
    building_id: 'bld-008',
  },

  {
    _id: 'ins-009-1',
    type: 'Complaint',
    scope: 'Install fire alarm',
    assignedTo: 'Dominik Strassman',
    requestedDate: '2025-09-11',
    status: 'Pending',
    building_id: 'bld-009',
  },
  {
    _id: 'ins-009-2',
    type: 'Complaint',
    scope: 'Install fire alarm',
    assignedTo: 'Dominik Strassman',
    requestedDate: '2025-09-11',
    status: 'Failed',
    building_id: 'bld-009',
  },
  {
    _id: 'ins-009-3',
    type: 'Complaint',
    scope: 'Safety walkthrough',
    assignedTo: 'Dominik Strassman',
    requestedDate: '2025-09-12',
    status: 'Pending',
    building_id: 'bld-009',
  },

  {
    _id: 'ins-010-1',
    type: 'Complaint',
    scope: 'Install fire alarm',
    assignedTo: 'Dominik Strassman',
    requestedDate: '2025-09-11',
    status: 'Pending',
    building_id: 'bld-010',
  },
  {
    _id: 'ins-010-2',
    type: 'Complaint',
    scope: 'Install fire alarm',
    assignedTo: 'Dominik Strassman',
    requestedDate: '2025-09-11',
    status: 'Failed',
    building_id: 'bld-010',
  },
  {
    _id: 'ins-010-3',
    type: 'Complaint',
    scope: 'Safety walkthrough',
    assignedTo: 'Dominik Strassman',
    requestedDate: '2025-09-12',
    status: 'Pending',
    building_id: 'bld-010',
  },
];
export const InspectionViewFields = [
  { label: 'Type', key: 'type', size: { xs: 2 } },
  { label: 'Scope', key: 'scope', size: { xs: 2 } },
  { label: 'Assigned to', key: 'assignedTo', size: { xs: 2 } },
  { label: 'Requested date', key: 'requestedDate', size: { xs: 2 } },
];

export const inspectionHaveVisitViewFields = [
  {
    label: 'Inspection began',
    key: 'inspectionBegan',
    value: '09/11/2025, 05:00:00pm',
    size: { xs: 2 },
  },
  {
    label: 'Inspection concluded',
    key: 'inspectionConcluded',
    value: '09/12/2025, 05:00:00pm',
    size: { xs: 2 },
  },
  {
    label: 'Total inspection hours',
    key: 'totalInspectionHours',
    value: '12',
    size: { xs: 2 },
  },
  {
    label: 'Inspected by',
    key: 'inspectedBy',
    value: 'Dominik Strassman',
    size: { xs: 2 },
  },
  {
    label: 'ReinspectionDays',
    key: 'ReinspectionDays',
    value: '23',
    size: { xs: 2 },
  },
  {
    label: 'Reinspection date',
    key: 'reinspectionDate',
    value: '02/12/2025',
    size: { xs: 2 },
  },
];
